
export default {
    events: [
        {
            name: "Baraat",
            day: "Friday",
            date: "November 23",
            year: "2018",
            location: "Location",
            address: "Address",
            city: "City",
        },
        {
            name: "Mehndi",
            day: "Friday",
            date: "November 23",
            year: "2018",
            location: "Location",
            address: "Address",
            city: "City",
        },
        {
            name: "Walimah",
            day: "Friday",
            date: "November 23",
            year: "2018",
            location: "Location",
            address: "Address",
            city: "City",
        }
    ],
    lodging: [
        {
            event: "Baraat",
            location: "Location",
            description: "(Event 1 Venue)",
            address: "Address",
            city: "City",
            phone: "(888) 888-8888",
            rate: "Rate",
            reference: "Wedding",
        },
        {
            event: "Walimah",
            location: "Location",
            description: "(Event 2 Venue)",
            address: "Address",
            city: "City",
            phone: "(888) 888-8888",
            rate: "Rate",
            reference: "Wedding",
        }
    ],

    couple: {
        groom: "Groom",
        bride: "Bride",
    },

    childName: "John Doe",

    parents: "John Doe",

    contactDetails: {
        email: "test@email.com",
        directContacts: [
            {
                name: "Name",
                relationship: "Groom's Brother",
                number: "(888) 888-888"
            },
            {
                name: "Name",
                relationship: "Groom's Sister",
                number: "(888) 888-888"
            },
            {
                name: "Name",
                relationship: "Groom's Mother",
                number: "(888) 888-888"
            }
        ]
    }
}

